import { Directive, Input } from '@angular/core';
import { SelectDirective } from './select.directive';
import { GA4 } from '../models/ga4.model';

@Directive({
    selector: '[ga4SelectItem]'
})
export class SelectItemDirective extends SelectDirective<GA4.SelectItem> {
    track: GA4.SelectItem = <GA4.SelectItem>{ __event_name: 'select_item', items: [] };
    @Input()
    private set name(data: string) {
        this.track.item_list_name = data;
    }
    @Input()
    private set id(data: string) {
        this.track.item_list_id = data;
    }
    @Input()
    private set items(data: Array<Omit<GA4.Item, '__event_name'>>) {
        this.track.items = data;
    }

}
